export default __webpack_public_path__ + "static/media/Book5.0748ceaf.pdf";